import {EditorState} from '@codemirror/state'
import {EditorView} from '@codemirror/view'
import {spacingControls} from '@github-ui/code-mirror/extensions/spacing-controls'

/** Defines configuration for editing written prose (as opposed to code). */
export const proseExtension = [
  // Enable spellcheck/autocorrect
  EditorView.contentAttributes.of({
    spellcheck: 'true',
    autocorrect: 'on',
    autocapitalize: 'sentences',
    writingsuggestions: 'true',
  }),
  spacingControls({
    indentUnit: 2,
    indentWithTabs: false,
    lineWrapping: true,
  }),
  // Apostrophes can exist inside of words (in contractions / possessives)
  // There's no need to register alphanumeric chars here as they are included by default
  EditorState.languageData.of(() => [{wordChars: "'"}]),
]
